export default __webpack_public_path__ + "static/media/map_pin_ferdigbehandlet_avvik_fra_kontrollør.88585172.svg";